import { IAppState } from '~/shared/store/types'

import { getPurchaseCommonEventParams } from './getPurchaseCommonEventParams'

export const getPurchaseStartedEventParams = (state: IAppState) => {
  const {
    email,
    productId,
    price,
    trialPriceId,
    currency,
    screenName,
    stripeAccountName,
    stripeAccountId,
    stripePriceId,
  } = getPurchaseCommonEventParams(state)

  return {
    email,
    productId: trialPriceId ? productId : stripePriceId,
    priceDetails: {
      price,
      trial: !!trialPriceId,
      currency,
    },
    screenName,
    stripeAccountName,
    stripeAccountId,
  }
}
